import { AnyAction } from 'redux';

import slice from '../reducer/slice';

type TOperation = () => AnyAction;

const operation: TOperation = () => slice.actions.setFilter({});

export default operation;
